<template>
  <div style="margin:5%;">
    <b-table striped hover :items="items"></b-table>
  </div>
</template>
<script>

import server from '../../api/server.vue'

const items = [
  { isActive: true, age: 40, first_name: 'Loading', last_name: 'Laoding' },
]

export default {
  name: 'Scanssm',
  data() {
    return {
        items: items
      };
  },
  methods: {
  },
  mounted: function () {
    // `this` est une référence à l'instance de vm
    server.getScanSMByName(this.$route.params.id_kanban).then( response => 
    {
      var formatedResult = []
      var items = response.data.scans
      var andonValue = ''
      for (var i = 0; i < items.length; i++)
      {
        if (items[i]['state'] == 'fast')
        {
          andonValue = 'danger'
          items[i]['state'] = ''
        }
        else if (items[i]['state'] == 'slow')
        {
          andonValue = 'danger'
          items[i]['state'] = ''
        }
        items[i]['_cellVariants'] = { isActive: 'success', state: andonValue, first_name: 'warning' }
        formatedResult.push(items[i])
      }

      this.items = formatedResult
      //_cellVariants: { isActive: 'success', age: 'info', first_name: 'warning' }
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/supermarket/scans.vue